import { useAuth } from 'hooks/UseAuth'

const useDisplayUserName = (
  displayName: string | null,
  userId: number | null | undefined,
  capitalize: boolean = false,
  genitive: boolean = false,
) => {
  const auth = useAuth()

  if (displayName === null && !userId) {
    return 'Anonymous user'
  }

  const isCurrentUser = userId === auth?.id
  if (isCurrentUser && capitalize && genitive) {
    return 'Your'
  }
  if (isCurrentUser && capitalize && !genitive) {
    return 'You'
  }
  if (isCurrentUser && !capitalize && genitive) {
    return 'your'
  }
  if (isCurrentUser && !capitalize && !genitive) {
    return 'you'
  }

  return `${displayName}${genitive ? "'s" : ''}`
}

export { useDisplayUserName }
